import * as React from "react";
const SvgFiRrTriangleMusic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-triangle-music_svg__a)">
      <path
        fill="#062147"
        d="M12.5 13C10.57 13 9 14.57 9 16.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5c0-.83-.29-1.593-.775-2.193l6.627-10.783a1 1 0 0 0-.33-1.375.997.997 0 0 0-1.374.328L13.577 13.17c-.34-.11-.701-.17-1.077-.17m0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m10.8-.978-2.928-4.562a1 1 0 0 0-1.684 1.08l2.92 4.55a2.53 2.53 0 0 1 .063 2.596 2.53 2.53 0 0 1-2.237 1.316H4.566a2.53 2.53 0 0 1-2.237-1.316 2.52 2.52 0 0 1 .055-2.583l7.772-12.111a2.21 2.21 0 0 1 1.843-.991h.003a2.22 2.22 0 0 1 1.843.991 1 1 0 0 0 1.669-1.102A4.2 4.2 0 0 0 13 3.119V1a1 1 0 1 0-2 0v2.119A4.22 4.22 0 0 0 8.48 4.9L.692 17.035a4.5 4.5 0 0 0-.112 4.623 4.5 4.5 0 0 0 3.985 2.344h14.868c1.68 0 3.169-.876 3.985-2.344.816-1.469.774-3.196-.12-4.636zM12 5l.002.001zh-.002z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-triangle-music_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTriangleMusic;
